import { put, call, takeEvery } from "redux-saga/effects";
import * as constants from "./actions";
import * as Actions from "./constants";
import { setLocalState, removeLocalState } from "../../utils/localStorage";
import * as navigations from "../../utils/navigation";
import { toast } from "react-toastify";

import * as _service from "./service";

function* loginSaga(loginPayload: any): Generator<any, void, any> {
  const { payload, route, history } = loginPayload;
  try {
    // Clear any stale tokens before login attempt
    yield call(removeLocalState, "access_token");
    yield call(removeLocalState, "refresh_token");
    yield call(removeLocalState, "tokenExpiresAt");

    const response = yield call(_service.login, payload);
    yield put(constants.loginSuccess(response?.data));
    yield call(setLocalState, "_currentUser", response?.data?.user);
    yield call(setLocalState, "access_token", response?.data?.access_token);
    yield call(setLocalState, "refresh_token", response?.data?.refresh_token);

    const expirationDate = new Date();
    expirationDate.setHours(expirationDate.getHours() + 1);
    yield call(setLocalState, "tokenExpiresAt", expirationDate.toISOString());

    yield call(history, route);
    yield call(toast.success, "Connexion réussie");
  } catch (error) {
    yield put(constants.loginFailed(error));
    yield call(toast.error, "Votre identifiant ou mot de passe est incorrect.");
  }
}

function* registerSaga(loginPayload: any): Generator<any, void, any> {
  const { payload, typeRoute, history } = loginPayload;

  try {
    const response = yield call(_service.register, payload);

    if (response.status === 200 || response.status === 201) {
      yield put(constants.registerSuccess(response?.data));
      yield call(history, `/verification-otp/${typeRoute}`);
      yield call(toast.success, "Un code OTP vous a été envoyé par mail.");
    } else {
      yield put(constants.registerFailed(response));
      yield call(
        toast.error,
        "Une erreur s'est produite veuillez, contacter le service support."
      );
    }
  } catch (error: any) {
    if (error?.response?.data) {
      if (error?.response?.data?.email) {
        yield call(toast.error, error?.response?.data?.email[0]);
      }
      if (error?.response?.data?.phone) {
        yield call(toast.error, error?.response?.data?.phone[0]);
      }
    } else {
      yield call(
        toast.error,
        "Une erreur s'est produite. Veuillez réessayer ou contacter le service client si l'erreur persiste."
      );
    }
    yield put(constants.registerFailed(error));
  }
}

function* registerCompanySaga(loginPayload: any): Generator<any, void, any> {
  const { payload, typeRoute, history } = loginPayload;

  try {
    const response = yield call(_service.registerCompany, payload);

    if (response.status === 200 || response.status === 201) {
      yield put(constants.registerCompanySuccess(response?.data));
      yield call(setLocalState, "_currentUser", response?.data?.user);
      if (response?.data?.access_token) {
        yield call(setLocalState, "access_token", response?.data?.access_token);
      }
      if (response?.data?.refresh_token) {
        yield call(setLocalState, "refresh_token", response?.data?.refresh_token);
      }

      const expirationDate = new Date();
      expirationDate.setHours(expirationDate.getHours() + 24);
      yield call(setLocalState, "tokenExpiresAt", expirationDate.toISOString());

      yield call(history, navigations.RECHERCHE);
      yield call(toast.success, "Inscription d'entreprise réussie avec succès.");
    } else {
      yield put(constants.registerCompanyFailed(response));
      yield call(
        toast.error,
        "Une erreur s'est produite veuillez, contacter le service support."
      );
    }
  } catch (error: any) {
    if (error?.response?.data) {
      const errorData = error?.response?.data;
      if (errorData?.user?.email) {
        yield call(toast.error, errorData?.user?.email[0]);
      } else if (errorData?.user?.phone) {
        yield call(toast.error, errorData?.user?.phone[0]);
      } else if (errorData?.demandeur) {
        yield call(toast.error, "Erreur dans les données de l'entreprise.");
      } else {
        yield call(
          toast.error,
          "Une erreur s'est produite. Veuillez réessayer ou contacter le service client si l'erreur persiste."
        );
      }
    } else {
      yield call(
        toast.error,
        "Une erreur s'est produite. Veuillez réessayer ou contacter le service client si l'erreur persiste."
      );
    }
    yield put(constants.registerCompanyFailed(error));
  }
}

function* verificationOtpSaga(loginPayload: any): Generator<any, void, any> {
  const { payload, typeRoute, history } = loginPayload;

  try {
    const response = yield call(_service.verificationOtp, payload);

    yield put(constants.verificationOtpSuccess(response?.data));

    if (response.status === 200 || response.status === 201) {
      yield call(setLocalState, "_currentUser", response?.data?.user);
      yield call(setLocalState, "access_token", response?.data?.access_token);
      yield call(setLocalState, "refresh_token", response?.data?.refresh_token);

      const expirationDate = new Date();
      expirationDate.setHours(expirationDate.getHours() + 24);
      yield call(setLocalState, "tokenExpiresAt", expirationDate.toISOString());

      yield call(history, navigations.RECHERCHE);
    }
  } catch (error) {
    yield put(constants.verificationOtpFailed(error));
    yield call(
      toast.error,
      "Une erreur s'est produite. Veuillez réessayer ou contacter le service client si l'erreur persiste."
    );
  }
}

function* forgotPasswordSaga(forgotPasswordPayload: any): Generator<any, void, any> {
  const { payload, history } = forgotPasswordPayload;
  try {
    const response = yield call(_service.forgotPassword, payload);
    if (response.status === 200 || response.status === 201) {
      yield put(constants.forgotPasswordSuccess(response?.data));
      yield call(history, navigations.LOGIN);
      yield call(
        toast.success,
        "Un mail de réinitialisation vous a été envoyé par mail."
      );
    } else {
      yield put(constants.forgotPasswordFailed(response));
      yield call(
        toast.error,
        "Une erreur s'est produite. Veuillez réessayer ou contacter le service client si l'erreur persiste."
      );
    }
  } catch (error) {
    yield put(constants.forgotPasswordFailed(error));
    yield call(
      toast.error,
      "Une erreur s'est produite. Veuillez réessayer ou contacter le service client si l'erreur persiste."
    );
  }
}

function* resetPasswordSaga(resetPasswordPayload: any): Generator<any, void, any> {
  const { payload, resetForm, history } = resetPasswordPayload;
  try {
    const response = yield call(_service.resetPassword, payload);

    if (response.status === 200 || response.status === 201) {
      yield put(constants.resetPasswordSuccess(response?.data));
      resetForm();
      yield call(history, navigations.LOGIN);
      yield call(toast.success, "Le mot de passe a été réinitialisé.");
    } else {
      yield put(constants.resetPasswordFailed(response));
      yield call(
        toast.error,
        "Une erreur s'est produite. Veuillez réessayer ou contacter le service client si l'erreur persiste."
      );
    }
  } catch (error) {
    yield put(constants.resetPasswordFailed(error));
    yield call(
      toast.error,
      "Une erreur s'est produite. Veuillez réessayer ou contacter le service client si l'erreur persiste."
    );
  }
}

function* logoutSaga(logoutPayload: any): Generator<any, void, any> {
  const { history } = logoutPayload;
  try {
    yield call(removeLocalState, "_currentUser");
    yield call(removeLocalState, "access_token");
    yield call(removeLocalState, "refresh_token");
    yield call(removeLocalState, "tokenExpiresAt");

    yield call(history, navigations.LOGIN);
  } catch (error) {
    console.error("Erreur lors de la déconnexion:", error);
  }
}

export default function* authSaga() {
  yield takeEvery(Actions.LOGIN_REQUESTING, loginSaga);
  yield takeEvery(Actions.REGISTER_REQUESTING, registerSaga);
  yield takeEvery(Actions.REGISTER_COMPANY_REQUESTING, registerCompanySaga);
  yield takeEvery(Actions.VERIFICATION_OTP_REQUESTING, verificationOtpSaga);
  yield takeEvery(Actions.FORGOT_PASSWORD_REQUESTING, forgotPasswordSaga);
  yield takeEvery(Actions.RESET_PASSWORD_REQUESTING, resetPasswordSaga);
  yield takeEvery(Actions.LOGOUT, logoutSaga);
}
